/* global window */
import Alpine from "alpinejs";
import morph from "@alpinejs/morph";
import mask from "@alpinejs/mask";
import ImportProgress from "./importer/alpine/ImportProgress";
import EpisodeFileUpload from "./alpine/EpisodeFileUpload";
import DispatchEvent from "./alpine/DispatchEvent";
import Tabs from "./alpine/Tabs";
import Datepicker from "./alpine/Datepicker";
import ConfirmationButton from "./alpine/ConfirmationButton";
import SubmitButton from "./alpine/SubmitButton";
import Gravatar from "./alpine/Gravatar";
import EpisodeDescriptionEditor from "./alpine/EpisodeDescriptionEditor";
import UploadImage from "./alpine/UploadImage";
import PreviewPodcastCover from "./alpine/PreviewPodcastCover";
import ExportTranscriptPdf from "./alpine/ExportTranscriptPdf";
import Pagination from "./alpine/Pagination";
import PasswordValidation from "./alpine/PasswordValidation";
import StripeElement from "./alpine/StripeElement";
import Modal from "./commerce/components/alpine/Modal";
import StackedBarChart from "./alpine/StackedBarChart";
import CopyToClipboard from "./commerce/components/alpine/CopyToClipboard";
import ShowAndHide from "./commerce/components/alpine/ShowAndHide";
import DropdownMenu from "./commerce/components/alpine/DropdownMenu";
import ApplePodcastsKey from "./alpine/ApplePodcastsKey";
import GenerateSlug from "./commerce/components/alpine/GenerateSlug";
import Combobox from "./commerce/components/alpine/Combobox";

export default () => {
  window.Alpine = Alpine;
  Alpine.plugin(morph);
  Alpine.plugin(mask);
  window.Alpine.data("Modal", Modal);
  window.Alpine.data("ImportProgress", ImportProgress);
  window.Alpine.data("Pagination", Pagination);
  window.Alpine.data("EpisodeFileUpload", EpisodeFileUpload);
  window.Alpine.data("DispatchEvent", DispatchEvent);
  window.Alpine.data("Tabs", Tabs);

  window.Alpine.data("Datepicker", Datepicker);
  window.Alpine.data("ConfirmationButton", ConfirmationButton);
  window.Alpine.data("SubmitButton", SubmitButton);
  window.Alpine.data("Gravatar", Gravatar);
  window.Alpine.data("UploadImage", UploadImage);
  window.Alpine.data("PreviewPodcastCover", PreviewPodcastCover);
  window.Alpine.data("ExportTranscriptPdf", ExportTranscriptPdf);
  window.Alpine.data("EpisodeDescriptionEditor", EpisodeDescriptionEditor);
  window.Alpine.data("PasswordValidation", PasswordValidation);
  window.Alpine.data("StripeElement", StripeElement);
  window.Alpine.data("StackedBarChart", StackedBarChart);
  window.Alpine.data("CopyToClipboard", CopyToClipboard);
  window.Alpine.data("ShowAndHide", ShowAndHide);
  window.Alpine.data("DropdownMenu", DropdownMenu);
  window.Alpine.data("ApplePodcastsKey", ApplePodcastsKey);
  window.Alpine.data("GenerateSlug", GenerateSlug);
  window.Alpine.data("Combobox", Combobox);
  window.Alpine.start();
};
